import {gaConfig} from '@stencil/hotels-config';
// SELECTOR FNS
import {
  hotelPersuasionSelector,
  reviewRatingSelector,
} from '@stencil/hotels-details-reducer/src/selectors';
import detailsPageClickGaPush from '@stencil/hotels-utils/src/details-page-click-ga-push';
import {detailsNavigationIdsAndValues} from '@stencil/hotels-utils/src/get-details-navigation-id-and-values';
import {scrollToEl} from '@stencil/hotels-utils/src/scroll-into-view-details';
// COLOR PALETTE
import {defaultTheme} from '@stencil/build-theme';
import React from 'react';
// HOOKS
import {useSelector} from 'react-redux';
// ICONS
import LeafStarPersuasionIcon from '../../../../../../stories/Icons/RankingIcon'; // 🐨change the name of the file to LeafStarPersuasionIcon if it makes more sense
import TriggerAnchorText from '../../../../../components/TriggerActionText';
import {getRatingsColor} from '@stencil/hotels-utils/src/get-ratings-colors';
// UTILS
import {ratingColorSelector} from '../../../../../utils/UI';
// STYLES
import * as S from './ReviewInfo.styles';

const {DetailsGAClickEventActions} = gaConfig;

const AggregateRatingAndNumberOfRatings = () => {
  const {hotelReviewRating, hotelRatingSource, numberOfReviews} = useSelector(reviewRatingSelector);
  const isTripAdvisor = hotelRatingSource === 3;
  if (hotelReviewRating) {
    return (
      <S.RatingContainer
        bgColor={
          isTripAdvisor
            ? defaultTheme.colors.goRatings.taRating
            : getRatingsColor(Number(hotelReviewRating))
        }
        itemProp="aggregateRating"
        itemScope
        itemType="http://schema.org/aggregateRating"
      >
        <span>
          {isTripAdvisor && (
            <S.TripadvisorImg
              src="https://gos3.ibcdn.com/trip_adviser-1557838494.png"
              alt="trip advisor logo"
            />
          )}
          <S.ReviewNumber color={ratingColorSelector(Number(hotelReviewRating))}>
            <span itemProp="worstRating" content="1" />

            <span itemProp="ratingValue">{hotelReviewRating}</span>
            {/* <span>{hotelReviewRating}</span> */}
            <span>/</span>
            <S.OutOfNumberForReview itemProp="bestRating">5</S.OutOfNumberForReview>
            {/* <S.OutOfNumberForReview>5</S.OutOfNumberForReview> */}
          </S.ReviewNumber>
        </span>
        <S.NumberOfRatingsStyled>
          <span itemProp="reviewCount">{numberOfReviews}</span>
          {/* <span>{numberOfReviews}</span> */}
          <span> RATINGS</span>
        </S.NumberOfRatingsStyled>
      </S.RatingContainer>
    );
  }

  return null;
};

// const mixedPersuasionsSelector = createSelector([mixedPersuasionsSelectorFn], (mixedPersuasions) => {
//   return mixedPersuasions;
// })

const Persuasion = () => {
  // const mixedPersuasions = useSelector(mixedPersuasionsSelector);

  const hotelPersuasion = useSelector(hotelPersuasionSelector);
  return (
    <S.PersuasionContainer>
      {!!hotelPersuasion.length && (
        <>
          <LeafStarPersuasionIcon
            width="2rem"
            height="2rem"
            fill={defaultTheme.colors.goYellow.base}
          />

          {hotelPersuasion.map(p => (
            <S.PersuasionText color={p.ccd?.tc} backgroundColor={p.ccd?.bgc} key={p.pt}>
              {p.pt}
            </S.PersuasionText>
          ))}
        </>
      )}
    </S.PersuasionContainer>
  );
};

function ReviewInfo() {
  return (
    <TriggerAnchorText
      onClick={e => {
        e.preventDefault();
        detailsPageClickGaPush({
          eventAction: DetailsGAClickEventActions.topReviewClick,
        });
        scrollToEl(detailsNavigationIdsAndValues.guestReviews.id);
      }}
    >
      <div>
        <AggregateRatingAndNumberOfRatings />
        <Persuasion />
      </div>
    </TriggerAnchorText>
  );
}

export default ReviewInfo;
